module.exports = window.FormData



//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-form-data/lib/browser.js
// module id = 496
// module chunks = 1